import domReady from '@wordpress/dom-ready';
import manifest from './../manifest.json';

domReady(async () => {
	const navbarCtaClass = `.${manifest.blockJsClass}`;
	const navbarCtaElements = document.querySelectorAll(navbarCtaClass);

	if (!navbarCtaElements) {
		return;
	}

	const { NavbarCta } = await import('./navbar-cta');

	const navbarCta = new NavbarCta({
		navbarCtaElements,
	});

	navbarCta.init();
});
